import { render, staticRenderFns } from "./Questions.Info.vue?vue&type=template&id=18235067&scoped=true&"
import script from "./Questions.Info.vue?vue&type=script&lang=js&"
export * from "./Questions.Info.vue?vue&type=script&lang=js&"
import style0 from "./Questions.Info.vue?vue&type=style&index=0&id=18235067&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18235067",
  null
  
)

export default component.exports